/* eslint-disable */
import algoliasearch from 'algoliasearch'
import instantsearch from 'instantsearch.js'
import { configure } from 'instantsearch.js/es/widgets'
import { connectMenu } from 'instantsearch.js/es/connectors'
export default {
  name: 'member-list',

  componentDidMount() {
    this.locale = document.querySelector('html').getAttribute('lang')

    this.widget = []
    const searchIndex = `${config.algolia.env}_frontUsers`

    this.search = instantsearch({
      indexName: searchIndex,
      searchClient: algoliasearch(
        config.algolia.applicationID,
        config.algolia.apiKeyUsers
      ),
      // numberLocale: this.locale,
      routing: true,
    })

    this.widget.push(
      configure({
        maxFacetHits: 100,
        // facetFilters: ['enabled:true'],
        // sortFacetValuesBy: 'alpha',
      })
    )

    const selectBoxes = this.el.querySelectorAll('[js-member-list-select]')
    /* for (const select of selectBoxes) {
      const attribute = select.getAttribute('js-member-list-select')
      this.widget.push(this.initSelect(select, attribute))
    }*/
    // refact for IE 11 #@$%°€£!!!!!
    Array.prototype.forEach.call(selectBoxes, select => {
      const attribute = select.getAttribute('js-member-list-select')
      this.widget.push(this.initSelect(select, attribute))
    })

    this.widget.push(this.filterWidget())

    this.search.addWidgets(this.widget)
    this.search.start()
  },

  initSelect(target, type) {
    const renderMenuSelect = renderOptions => {
      const { items } = renderOptions
      const selectItems = items
        .map(item => `<option value="${item.value}">${item.label}</option>`)
        .join('')

      target.innerHTML = target.innerHTML + selectItems
    }

    // Create the custom widget
    const customMenuSelect = connectMenu(renderMenuSelect)

    return customMenuSelect({
      attribute: type,
      sortBy: ['name:asc'],
      limit: 900,
    })
  },

  filterWidget() {
    // HITS
    const autocompleteContainer = this.el.querySelector(
      '[js-member-list-autocomplete]'
    )
    const input = this.el.querySelector('[js-member-list-input]')

    const widget = {
      init(opts) {
        const { helper, state } = opts

        input.addEventListener('input', () => {
          if (input.value !== '') {
            autocompleteContainer.classList.remove('is-hidden')

            const titleValues = helper
              .searchForFacetValues('activityType.title', input.value)
              .then(({ facetHits }) => {
                const data = facetHits.map(item => item.value)

                return data
              })

            const nameValues = helper
              .searchForFacetValues('name', input.value)
              .then(({ facetHits }) => {
                const data = facetHits.map(item => item.value)
                return data
              })

            Promise.all([nameValues, titleValues]).then(data => {
              const values = data[0].concat(data[1])
              autocompleteContainer.innerHTML = values
                .map(val => `<li data-value="${val}">${val}</li>`)
                .join('')
              const list = autocompleteContainer.querySelectorAll('li')
              /*for (const li of list) {
                li.addEventListener('click', () => {
                  input.value = li.dataset.value
                  autocompleteContainer.classList.add('is-hidden')
                })
              }*/
              Array.prototype.forEach.call(list, li => {
                li.addEventListener('click', () => {
                  input.value = li.dataset.value
                  autocompleteContainer.classList.add('is-hidden')
                })
              })
            })
          } else {
            autocompleteContainer.innerHTML = ``
            autocompleteContainer.classList.add('is-hidden')
          }
        })
      },
    }

    return widget
  },
}
